import React, { memo } from 'react';

const OrderNotes = ({ specialInstructions }) => {
  return (
    <>
      <div className="orderNoteBlock">
        <div>
          <strong className="note uppercase">Note:</strong>
        </div>
        <div style={{ marginLeft: '10px' }} className="instructions">
          {specialInstructions?.split('\n')?.map((item, index) => (
            <i key={index} style={{ display: 'block', fontStyle: 'italic' }}>
              {item}
            </i>
          ))}
        </div>
      </div>
      <hr className="line-header" />
    </>
  );
};

export default memo(OrderNotes);